export default function PropertyHeader() {
  return (
    <div className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-6 md:py-8">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
          <div className="flex-1">
            <p className="text-sm text-amber-700 font-medium mb-2 tracking-wide uppercase">
              słupski &rsaquo; Słupsk &rsaquo; Bydlino
            </p>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-snug max-w-2xl">
              Budynek mieszkalny o charakterze rezydencji w pasie środkowego wybrzeża w odległości 9 km od morza
            </h1>
          </div>
          <div className="flex flex-row lg:flex-col items-start lg:items-end gap-4 lg:gap-2 flex-wrap">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-stone-800 whitespace-nowrap">849 000 EUR</div>
              <div className="text-sm text-gray-500 mt-0.5">3 589,85 EUR / m²</div>
            </div>
            <div className="flex gap-4 mt-1">
              <div className="text-center">
                <div className="text-lg font-bold text-gray-800">7</div>
                <div className="text-xs text-gray-500">Pokoi</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-gray-800">236,50 m²</div>
                <div className="text-xs text-gray-500">Powierzchnia</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-gray-800">9 600 m²</div>
                <div className="text-xs text-gray-500">Działka</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
